module.exports = __webpack_public_path__ + "img/home-selected-logo.3e355195.png";